<template>
  <three-panel-condition
    :target="target"
    :conditions="conditions"
    :prefix="prefix"
    :data="data"
    :loading="loading"
    :title="title"
    :name="name"
    :predicates="predicates"
    @close="emit('close')"
  />
</template>

<script setup lang="ts">
import { useI18n } from '@/composables';
import ThreePanelCondition from './three-panel-condition/three-panel-condition.vue';
import { useFlowThreePanelDictionaryCondition } from './useFlowThreePanelDictionaryCondition';

defineProps<{
  target?: unknown;
  conditions: Record<string, unknown>;
}>();

const emit = defineEmits<{
  close: [];
}>();

const { t } = useI18n();

const { data, loading, prefix, title, name, predicates } = useFlowThreePanelDictionaryCondition({
  apiKey: 'browsers-v2',
  prefix: 'browser',
  title: t('Browser and version'),
  name: t('Browsers'),
  withVersionPredicates: true,
});
</script>

<style lang="scss"></style>
